var _path, _path2, _path3, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBrevy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 75,
    height: 74,
    viewBox: "0 0 75 74",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M39.411 57.7489C31.8082 62.2037 24.2239 66.6773 16.6025 71.0945C7.8006 76.1897 0.318568 71.9515 0.225623 61.7328C0.0676174 45.1286 -0.0160327 28.5244 0.0025562 11.9202C0.0118507 1.35298 7.466 -2.97937 16.5374 2.16294C24.196 6.50471 31.8361 10.8747 39.4761 15.2353C45.6941 18.9273 51.9028 22.6569 58.1487 26.3017C68.0008 32.0562 68.1309 40.4949 58.4554 46.2964C52.098 50.1014 45.7592 53.9252 39.411 57.7489ZM31.204 54.4902C31.6781 54.9235 32.0963 55.7617 32.8213 55.1307C33.1001 54.8952 32.9235 54.1135 32.9514 53.5861C32.9514 42.2937 32.9514 30.9919 32.9514 19.6996C33.0257 19.012 33.4626 18.1267 32.5331 17.8253C32.1707 17.7123 31.5944 18.2962 31.1111 18.56C30.507 18.9084 29.9121 19.2663 29.308 19.6148C28.7038 19.9633 28.0904 20.3023 27.4863 20.6508C23.1922 23.0618 18.7495 25.2374 14.632 27.931C8.08873 32.2257 8.19097 40.7774 14.8179 44.9685C20.1529 48.3496 25.7296 51.3352 31.204 54.4902Z",
    fill: "url(#paint0_linear_94_348)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M39.4082 57.8353C45.7563 54.0115 52.0951 50.1878 58.4432 46.3828C68.1281 40.5907 67.9886 32.152 58.1365 26.3881C51.8907 22.7338 45.6913 19.0137 39.464 15.3217C40.412 10.7822 45.0221 10.8293 47.8383 8.70077C51.7698 5.73405 56.3985 3.74681 60.581 1.10973C65.7208 -2.13012 75.2011 2.06096 74.9967 9.46364C74.4948 27.6313 74.8665 45.8272 74.8108 64.0136C74.7922 71.1997 67.9329 76.2101 61.5848 73.0174C54.2979 69.3443 47.5594 64.5599 40.57 60.2558C39.687 59.6907 39.5197 58.7865 39.4082 57.8353Z",
    fill: "#F1F1F1"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M29.2959 19.713C29.9 19.3646 30.4949 19.0067 31.099 18.6582C31.4522 19.4776 32.1214 19.7507 32.9393 19.7884C32.9393 31.0808 32.9393 42.3825 32.9393 53.6749C32.2143 53.6938 31.5637 53.8539 31.1919 54.5791C25.7175 51.424 20.1408 48.4384 14.8058 45.0667C8.17887 40.8756 8.07663 32.324 14.6199 28.0293C18.7281 25.3357 23.1801 23.1601 27.4742 20.749C29.0542 22.1429 29.1472 20.8715 29.2959 19.713Z",
    fill: "#F1EFEF"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_94_348",
    x1: 0,
    y1: 36.6272,
    x2: 65.6258,
    y2: 36.6272,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AB35C4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.314468,
    stopColor: "#AB35C4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.793552,
    stopColor: "#CE428A"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBrevy);
export default __webpack_public_path__ + "static/media/brevy.8983912fa0748d3e4d9b9c6fcb334709.svg";
export { ForwardRef as ReactComponent };